module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"more_details":"Plus de détails"}}')
  delete Component.options._Ctor
}
